<template>
  <div class="services-sidebar-section__filter">
    <div v-if="sortOptions.price !== undefined" :class="[
      activeFilter === 1 ? 'active' : '',
      sortOptions.price === 1 ? 'bottom' : 'top'
    ]" @click="$emit('sort-by-price')">
      {{ getLocalization('By price') }}
      <span class="sort-arrow"></span>
    </div>

    <div v-if="sortOptions.quantity !== undefined" :class="[
      activeFilter === 2 ? 'active' : '',
      sortOptions.quantity === 1 ? 'bottom' : 'top'
    ]" @click="$emit('sort-by-quantity')">
      {{ getLocalization('By quantity') }}
      <span class="sort-arrow"></span>
    </div>

    <div v-if="sortOptions.top !== undefined" :class="[
      activeFilter === 3 ? 'active' : '',
      sortOptions.top === 1 ? 'bottom' : 'top'
    ]" @click="$emit('sort-by-top')">
      {{ getLocalization('By top') }}
      <span class="sort-arrow"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeFilter: {
      type: Number,
      default: 0
    },
    sortOptions: {
      type: Object,
      required: true,
      validator: (value) => {
        return Object.keys(value).some(key =>
            ['price', 'quantity', 'top'].includes(key)
        )
      }
    }
  },
  methods: {
    getLocalization(key) {
      return this.$root.getLocalization
          ? this.$root.getLocalization(key)
          : key;
    }
  }
}
</script>

